<template>
  <v-card>
    <v-toolbar dark color="primary" dense class="mb-5">
      <v-btn icon dark @click="close">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-toolbar-title>Notícia</v-toolbar-title>
      <v-spacer />
    </v-toolbar>

    <v-form ref="form">
      <v-row justify="start" no-gutters class="pa-2">
        <v-col class="d-flex" lg="2" md="2">
          <v-checkbox v-model="news.active" label="Ativo?" />
        </v-col>
      </v-row>

      <v-row justify="start" no-gutters class="pa-2 mt-0">
        <v-col class="d-flex pr-5" lg="6" md="12" sm="12">
          <v-text-field
            v-model="news.author"
            :rules="$rules.required"
            required
            outlined
            dense
            label="Autor *"
          />
        </v-col>

        <v-col class="d-flex pr-5" lg="6" md="12" sm="12">
          <v-select
            v-model="news.unit"
            :items="unities"
            :rules="$rules.required"
            required
            label="Unidade *"
            dense
            outlined
          />
        </v-col>
      </v-row>

      <v-row justify="center" no-gutters class="pa-2 mt-0">
        <v-col class="d-flex pr-5" lg="6" md="12" sm="12">
          <v-text-field
            v-model="news.headline"
            :counter="200"
            outlined
            dense
            label="Título da Notícia *"
            :rules="$rules.required"
            required
          />
        </v-col>

        <v-col class="d-flex pr-5" lg="6" md="12" sm="12">
          <v-text-field
            v-model="news.caption"
            outlined
            :counter="300"
            dense
            label="Subtítulo da Notícia *"
            :rules="$rules.required"
            required
          />
        </v-col>
      </v-row>

      <v-row justify="start" no-gutters class="pa-2 mt-0">
        <v-col class="d-flex pr-5">
          <v-select
            v-model="news.galleryId"
            :items="galleries"
            item-text="name"
            item-value="id"
            chips
            label="Galerias"
            multiple
            outlined
          />
        </v-col>
      </v-row>

      <v-row justify="start" no-gutters class="pa-2 mt-0">
        <v-col class="d-flex pr-5">
          <v-file-input
            v-model="imagesUpload"
            outlined
            :images="imagesPreview"
            label="Clique para adicionar imagens do tamanho de 1024x768"
            prepend-icon="mdi-camera"
            accept="image/jpeg, image/png"
            @change="onFilesSelected"
          />
        </v-col>
      </v-row>
      <v-dialog v-model="dialogCropImage" persistent>
        <v-card>
          <div>
            <v-card-title class="text-h5"> Recorte da imagem para tamanho 1024x768 </v-card-title>
          </div>
          <div>
            <v-card-text>
              Para melhor visualização da imagem no Informa Site, recomendamos utilizar o tamanho da
              imagem em 1024x768. <br />
              Utilize o "scroll" do mouse para ajustar a imagem.
              <br />
              Clique e segure na imagem para arrastar e posicionar.
            </v-card-text>
          </div>
          <div style="padding-left: 600px">
            <resize-image
              ref="image"
              :target-width="resizeImageParams.targetWidth"
              :target-height="resizeImageParams.targetHeight"
              :min-aspect-ratio-value1="resizeImageParams.minAspectRatioValue1"
              :min-aspect-ratio-value2="resizeImageParams.minAspectRatioValue2"
              :max-aspect-ratio-value1="resizeImageParams.maxAspectRatioValue1"
              :max-aspect-ratio-value2="resizeImageParams.maxAspectRatioValue2"
              :image-param="imagesPreview"
            />
          </div>
          <v-card-actions>
            <v-btn color="red darken-1" text @click="cancelCropImage()"> Cancelar </v-btn>
            <v-btn color="green darken-1" text @click="cropImageOnConfirm"> Confirmar </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-col>
        <gallery
          :images="imagesPreview"
          :rules="$rules.required"
          required
          @image-deleted="onDeleteImage"
        />
      </v-col>

      <v-row justify="start" no-gutters class="pa-2 mt-0">
        <v-col class="pr-5">
          <kosmo-editor v-model="news.text" :max-length="5000" label="Texto da notícia *" />
        </v-col>
      </v-row>

      <v-row justify="start" no-gutters class="pa-2 mt-6">
        <v-col class="pr-5">
          <v-file-input
            v-model="attcUpload"
            label="Clique para adicionar novos arquivos"
            multiple
            outlined
            show-size
            counter
            accept="application/pdf,application/vnd.ms-excel"
          >
            <template #selection="{ index, text }">
              <v-chip v-if="index < 4" class="white accent-4" label>
                {{ text }}
              </v-chip>

              <span v-else-if="index === 4" class="text-overline grey--text text--darken-3 mx-2">
                +{{ attcUpload.length - 4 }} arquivo(s)
              </span>
            </template>
          </v-file-input>
        </v-col>
      </v-row>
    </v-form>

    <v-row class="mt-10" justify="center" no-gutters>
      <v-card-actions>
        <v-btn color="secondary" @click="close"> Cancelar </v-btn>
        <v-btn v-if="loading === true" color="primary" loading @click="submit" />
        <v-btn v-else color="primary" @click="submit"> Salvar </v-btn>
      </v-card-actions>
    </v-row>
  </v-card>
</template>

<script>
import sanitize from "sanitize-filename";
import NewsService from "../../../services/news.service";
import GalleryService from "../../../services/gallery.service";
import { createFeaturedPhoto } from "../../../services/photos-service";
import { image } from "../../../services/upload-service";
import ResizeImage from "../../../components/shared/ResizeImage.vue";
import imageFormatter from "../../../utils/convert-image-to-file";

export default {
  name: "NewsForm",
  components: {
    ResizeImage,
  },
  props: {
    populateWith: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      unities: [
        "Cassems Sede",
        "Cassems Corumbá",
        "Cassems Aquidauana",
        "Cassems Coxin",
        "Cassems Ponta Porã",
        "Cassems Dourados",
        "Cassems Naviraí",
        "Hospital Campo Grande",
      ],
      galleries: [],
      news: {
        active: false,
        author: "",
        unit: "",
        headline: "",
        caption: "",
        galleryId: "",
        text: "",
        attc: [],
      },
      attcUpload: [],
      linkFiles: [],
      resizeImageParams: {
        targetWidth: 1024,
        targetHeight: 768,
        minAspectRatioValue1: 4,
        minAspectRatioValue2: 3,
        maxAspectRatioValue1: 4,
        maxAspectRatioValue2: 3,
      },
      imagesPreview: [],
      imagesUpload: null,
      loading: false,
      dialogCropImage: false,
    };
  },
  async created() {
    if (this.populateWith.id) {
      const selectedGalleries = this.populateWith.newsGallery.map(({ gallery }) => ({
        name: gallery.name,
        id: gallery.id,
      }));
      this.news = { ...this.populateWith };
      this.news.galleryId = selectedGalleries;
      this.imagesPreview = this.news?.featuredImage ? [this.news?.featuredImage] : [];

      this.attcUpload = this.news?.attc ?? [];
    }

    const data = await GalleryService.getGalleries();
    this.galleries = data.map(({ name, id }) => ({ name, id }));
  },
  methods: {
    close() {
      this.$emit("close-dialog");
    },

    async checkFileAndUpload() {
      const uploadFilesPromises = this.attcUpload.map(async (item) => image(item));
      const uploadFilesResponse = await Promise.all(uploadFilesPromises);
      const arrayFilesLinks = uploadFilesResponse.map((item) => item[0]);
      this.news = { ...this.news, attc: arrayFilesLinks };
    },
    onFilesSelected(files) {
      if (!files) return;
      this.dialogCropImage = true;
      this.imagesPreview = [URL.createObjectURL(files)];
    },
    onDeleteImage(index) {
      this.imagesPreview.splice(index, 1);
      if (this.imagesUpload) {
        this.imagesUpload.splice(index, 1);
      }

      this.news = { ...this.news, link: null };
    },
    async checkImagesUploadAndCreatePhoto() {
      if (this.imagesUpload) {
        const imageType = imageFormatter.getMimeType(this.imagesPreview);
        const formattedTitle = sanitize(this.news.headline);
        const imageFormatted = imageFormatter.convertImageToFile(
          this.imagesPreview,
          `${formattedTitle.substring(0, 10)}.${imageType}`
        );

        const photo = await createFeaturedPhoto(imageFormatted);
        this.news = { ...this.news, link: photo.link };
      }
    },
    async updateNews() {
      try {
        this.loading = true;
        await this.checkImagesUploadAndCreatePhoto();
        await this.checkFileAndUpload();
        await NewsService.updateNews({ ...this.news });
        this.$emit("news-edited", this.news);
        this.$toast.success("Noticia editada com sucesso");
        this.loading = false;
        this.close();
      } catch (e) {
        this.$handleHttpError(e);
        this.loading = false;
      }
    },

    cropImageOnConfirm() {
      const { coordinates, canvas } = this.$refs.image.$refs.cropper.getResult();
      this.coordinates = coordinates;
      const imageToArray = canvas.toDataURL();
      this.imagesPreview = [imageToArray];
      this.dialogCropImage = false;
    },

    cancelCropImage() {
      this.dialogCropImage = false;
      this.imagesUpload = null;
      this.imagesPreview = [];
    },

    async submit() {
      const textExededMaxSize = this.news.text.length > 5000;

      if (!this.$refs.form.validate()) {
        this.$toast.error("Verifique os campos e tente novamente");
        return;
      }

      if (textExededMaxSize) {
        this.$toast.error("Limite de caracteres atingido no campo de texto!");
        return;
      }

      if (this.populateWith.id) {
        await this.updateNews();
        return;
      }

      try {
        this.loading = true;
        await this.checkImagesUploadAndCreatePhoto();
        await this.checkFileAndUpload();
        await NewsService.createNews({ ...this.news });
        this.$emit("news-added", { ...this.news });
        this.clearForm();
        this.$toast.success("Notícia cadastrada com sucesso");
        this.loading = false;
        this.close();
      } catch (e) {
        this.$handleHttpError(e);
        this.loading = false;
      }
    },

    clearForm() {
      this.$refs.form.reset();
      this.news.text = null;
      this.news.author = null;
      this.news.headline = null;
      this.news.headline = null;
      this.news.caption = null;
      this.news.galleryId = null;
      this.news.attc = [];
      this.news.active = false;
      this.news.unit = null;
      this.imagesPreview = [];
      this.attcUpload = [];
      this.$refs.form.resetValidation();
    },
  },
};
</script>
